<div
    class="sb-radio-card" 
    [class.sb-radio-card-disabled]="disabled"
    [class.sb-radio-card-readonly]="isReadOnly"
    [class.sb-radio-card-selected]="cardClicked && hasSelectedState"
    [attr.data-sb-qa]="qaTag"
    (click)="CardClicked()">
    <div class="sb-radio-card-lead-icon">
        <ng-content select="[radioCardPrefix]"></ng-content>
    </div>

    <div class="sb-radio-card-content">
        <div class="sb-radio-card-header">
            <h5 class="sb-radio-card-title">
                <ng-content select="[title]"></ng-content>
            </h5>

            @if (completed) {
                <lib-icon
                    [size]="IconSize.Small"
                    [icon]="Icon.Common.CheckCircle"></lib-icon>
            }
            <ng-content select="[radioCardSuffix]"></ng-content>
        </div>

        <div class="sb-radio-card-body">
            <div
                class="sb-radio-card-tags-row"
                [hidden]="!tagsTitleContent.textContent">
                <div class="sb-radio-card-tags-title-wrapper">
                    <small class="sb-radio-card-tags-title" #tagsTitleContent>
                        <ng-content select="[tagsTitle]"></ng-content>
                    </small>
                </div>
                <div class="sb-radio-card-tags-body">
                    <ng-content select="[tags]"></ng-content>
                </div>
            </div>
            <p class="sb-radio-card-text">
                <ng-content select="[text]"></ng-content>
            </p>
        </div>

        <div class="sb-radio-card-footer"
            [hidden]="!footerContent.textContent">
            <h6 class="sb-radio-card-footer-text" #footerContent>
                <ng-content select="[footer]"></ng-content>
            </h6>
        </div>
    </div>
</div>
